import { createSelector } from 'reselect';
import { get } from 'lodash-es';

export const localState = ({ sockets }) => get(sockets, 'status');

export const getSocketConnectionState = createSelector(localState, ({ connection }) => connection);
